import { IHttpClient } from "../../lib/http";

export async function regenPropertyCache(
  httpClient: IHttpClient,
  propertyTicker: string,
  forceRegenCache?: boolean
): Promise<void> {
  return httpClient.post(
    forceRegenCache
      ? `/api/property/${propertyTicker}/cache?forceRegenCache=true`
      : `/api/property/${propertyTicker}/cache`,
    undefined
  );
}
